exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".player-card{\n\n}\n\n.player-card li {\n  list-style: none;\n  padding-right: 2vh;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Space-Janitor/src/app/player/player.component.css
// module id = ../../../../../src/app/player/player.component.css
// module chunks = main